import {
  DataSourceSetupComposite,
  enumATSModes
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/DataSourceSetupComposite";

export const PaycorSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const isAdditionalSource = importType !== "import";
  const atsType = isAdditionalSource ? enumATSModes.notATS : undefined;
  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={isAdditionalSource}
      showLoadHeaders={isAdditionalSource}
      importType={importType}
      ATSType={atsType}
    />
  );
};
